const mockCustomSettings = {};

export const mockCustomSettingsGet = (_body, _params, _options) => {
  const mockData = { userSettingsPayload: JSON.stringify(mockCustomSettings) };
  return mockData;
};

export default mockCustomSettingsGet;
